export default {
  USER: 'gp_consult_user',
  AUTH_TOKEN: 'gp_consult_token'
}